// removed by extract-text-webpack-plugin
module.exports = {"carousel":"_1UjZ_A1RC5-tL5_p5l0gdc","Carousel_side":"_1f_NeU4J2QEu9xSUH6Q_tv","Carousel_side_right":"_3vLHaf_wbJuUXGquGc_dGo","dotsClass":"NIeLzp0rYnuga0GCC8oxf","slick-active":"_34cCFm928E-W9lb025q8_g","lie":"yPH0ThE-6boiCVDM9AIkR","imga":"_28f2tYQeiFkwzI953wwUmG","btn_shop":"_29hmW3iBhr9nQNtZbAFAH4","btn_poa":"_39cVqCGpTZA8tJeKYXfqIP"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/GoeasyCarousel/GoeasyCarouselTsqy.scss
 ** module id = 260
 ** module chunks = 0
 **/